/* eslint-disable no-template-curly-in-string */
export default function useEmailState() {
  // 邮件名称组
  const messageNames = [
    {
      label: "计划单修改审核邮件",
      type: "UPDATE_APPROVE",
      insertArguments: [0, 1, 2, 3, 8, 9, 10, 11],
    },
    {
      label: "计划单修改通知邮件",
      type: "UPDATE_INFORM",
      insertArguments: [0, 1, 8, 9, 10, 11],
    },
    {
      label: "计划结果费用差审核邮件",
      type: "EXPENSE_APPROVE",
      insertArguments: [0, 1, 6, 7, 8, 9, 10, 11, 12],
    },
    {
      label: "排线结果发送邮件",
      type: "SCHEDULE_SEND",
      insertArguments: [0, 1, 8, 9, 10, 11],
    },
    {
      label: "排线结果异常邮件",
      type: "SCHEDULE_EXCEPTION",
      insertArguments: [0, 1, 8, 9, 10, 11],
    },
    {
      label: "满载率不达标审核邮件",
      type: "LOAD_FACTOR_APPROVE",
      insertArguments: [0, 1, 4, 5, 8, 9, 10, 11],
    },
    {
      label: "计划结果费用差通知邮件",
      type: "EXPENSE_INFORM",
      insertArguments: [0, 1, 6, 7, 8, 9, 10, 11],
    },
  ];

  // 插入参数字典值
  const insertArguments = {
    计划单号: "${PLAN_MSG_CODE}",
    计划单名称: "${PLAN_MSG_NAME}",
    计划单修改原因: "${PLAN_MSG_MODIFY_REASON}",
    计划单修改链接: "${PLAN_MSG_MODIFY_LINK}",
    满载率申请原因: "${LOAD_FACTOR_APPLICATION_REASON}",
    满载率不达标链接: "${LOAD_FACTOR_APPLICATION_LINK}",
    费用差金额: "${EXPENSE_VARIANCE_TOTAL_PRICE}",
    费用差申请链接: "${EXPENSE_VARIANCE_APPLICATION_LINK}",
    当前时间: "${CURRENT_TIME}",
    当前日期: "${CURRENT_DATE}",
    修改人: "${MODIFY_USER_NAME}",
    修改人手机号: "${MODIFY_USER_PHONE}",
    费用差申请原因: "${EXPENSE_VARIANCE_REASON}",
  };

  // 不需要填写审批人手机号的邮件类型
  const unwantedApproverMobile = ['UPDATE_APPROVE', 'EXPENSE_APPROVE', 'LOAD_FACTOR_APPROVE']

  return {
    messageNames,
    insertArguments,
    unwantedApproverMobile,
  };
}
